<template>
    <section class="section s-cart">
        <div class="container" v-for="(restaurant, restaurant_id) in basket.basket" :key="restaurant_id">
            <div class="main_cart">
                <div class="cart_table">
                    <router-link tag="div" :to="'/restaurant/' + restaurant_id" class="cart_restaurant">
                      <img class="cart_img" :src="restaurant.logo" alt="">
                      <h2>{{restaurant.name}}</h2>
                    </router-link>
                    <div class="cart_dish" v-for="product in restaurant.products" :key="product.id">
                        <div class="dish_img">
                            <img v-if="product.photo !== 'https://img.when-hungry.com/'" :src="product.photo" alt="">
                        </div>

                        <div class="dish_description">
                            <p>{{product.category}}</p>
                            <h2>{{product.name}}</h2>
                            <p v-html="product.desc"></p>
                            <div class="dish_price small">
                              <span class="main_price" style="display: none">16000 руб</span>
                              <span>{{product.price}}</span>
                            </div>
                            <!--div class="sale_box">
                              <div class="sale_item">
                                <h2>АКЦИЯ: блюдо в подарок</h2>
                              </div>
                              <div class="sale_item">
                                <h2>28 июня 2020 13:30</h2>
                              </div>
                            </div>
                            <span>30 см</span-->
                        </div>
                        <div class="dish_counter">
                          <div class="dish_price_sm">
                            <span>{{product.price}}</span>
                          </div>
                          <div class="dish_price">
                            <!--span class="main_price">16000 руб</span-->
                            <span>{{product.price}}</span>
                          </div>

                          <div class="number">

                            <span class="minus" @click="minusBasket(product.id)">-</span>
                            <input type="text" :value="product.quantity" />
                            <span class="plus" @click="plusBasket(product.id)">+</span>

                          </div>
                          <div @click="removeBasket(product.id)" class="dish_cancel">
                            <span class="cross">x</span>
                          </div>
                        </div>
                        <!--div class="sale_box small">
                          <div class="sale_item">
                            <h2>АКЦИЯ: блюдо в подарок</h2>
                          </div>
                          <div class="sale_item">
                            <h2>28 июня 2020 13:30</h2>
                          </div>
                        </div-->
                    </div>
                    <div class="post_price_box" v-if="parseInt(restaurant.free) === -1">
                      <h2>Доставка</h2>
                      <span>{{restaurant.delivery_price}}</span>
                    </div>
                    <div class="restaurant_description">

                      <div class="review main">
                        <div class="delivery_box">
                          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/delivery.svg" alt="">
                          <span>{{restaurant.delivery_time}} мин</span>
                        </div>
                        <div class="minimal_box">
                          <span>от {{restaurant.minimal}}</span>
                        </div>
                      </div>

                      <div class="review" v-if="parseInt(restaurant.free) === -1">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/icon_good.svg" alt="">
                        <span>У ресторана “{{restaurant.name}}” время доставки - {{restaurant.delivery_time}} минут</span>
                      </div>
                      <div class="review" v-else-if="parseInt(restaurant.free) === 0">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/icon_good.svg" alt="">
                        <span>У ресторана “{{restaurant.name}}” время доставки - {{restaurant.delivery_time}} минут, бесплатная доставка</span>
                      </div>
                      <div class="review" v-else>
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/icon_good.svg" alt="">
                        <span>У ресторана “{{restaurant.name}}” время доставки - {{restaurant.delivery_time}} минут, стоимость доставки {{restaurant.delivery_price}}, бесплатная доставка от {{restaurant.free}}</span>
                      </div>

                      <div class="review" v-if="parseInt(restaurant.minimal) > parseInt(restaurant.amount)">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/cart/icon_bad.svg" alt="">
                        <span>Внимание! У ресторана “{{restaurant.name}}” минимальная сумма заказа {{restaurant.minimal}}. Вам необходимо дозаказать ещё на {{(parseInt(restaurant.minimal) - parseInt(restaurant.amount))}} {{basket.valute}} <router-link :to="'/restaurant/' + restaurant_id" class="cart__feature__link">Дозаказать</router-link></span>
                      </div>
                    </div>

                    <div class="post_agreement" v-if="parseInt(restaurant.self)">
                        <input type="checkbox" name="myself" :id="'myself' + restaurant_id" v-model="restaurant.selfCheck" value="1">
                        <label :for="'myself' + restaurant_id" id="myself_label"></label>
                        Самовывоз. Заберу сам в ресторане со скидкой {{restaurant.self}} {{restaurant.self_type}}
                    </div>

                    <div class="post_agreement" v-if="auth.user && parseInt(restaurant.bonus)">
                      <input type="checkbox" name="pay_bonus" :id="'pay_bonus' + restaurant_id" v-model="restaurant.bonusCheck" value="1">
                      <label :for="'pay_bonus' + restaurant_id" id="pay_bonus_label"></label>
                      Оплата бонусами. Оплатить <strong>(до {{restaurant.bonus}} {{restaurant.bonus_type}})</strong> бонусами
                      <div class="range_box">
                        <div class="change_range">
                          <input class="range" type="range" id="min_amount_range_3"  v-model="restaurant.bonusValue" name="min_amount_range" min="0" :max="(parseInt(restaurant.amount)/100)*parseInt(restaurant.bonus)">
                        </div>
                        <p class="range_value">{{restaurant.bonusValue}} {{basket.valute}}</p>
                      </div>
                    </div>

                    <div class="cart_totall">
                        <p>
                            Итого:
                        </p>
                        <span>
                                {{(parseInt(restaurant.amount) + (restaurant.selfCheck?0:((parseInt(restaurant.amount)>=parseInt(restaurant.free)?0:parseInt(restaurant.delivery_price))))) - ((restaurant.selfCheck?parseInt(restaurant.selfValue):0) + (restaurant.bonusCheck?parseInt(restaurant.bonusValue):0))}} {{basket.valute}}
                            </span>
                    </div>

                </div>
                <!-- container end -->
            </div>
        </div>
    </section>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'cartBody',
  props: ['basket', 'auth'],
  methods: {
    plusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/plus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    minusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    removeBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('all', 1)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cartBody.vue